export const fr = {
  "language.label": "Langue",
  "language.el": "Ελληνικά",
  "language.en": "English",
  "language.fr": "Français",

  "common.loading": "Chargement...",
  "common.error": "Erreur",
  "common.empty": "Vide",
  "common.save": "Enregistrer",
  "common.cancel": "Annuler",
  "common.edit": "Modifier",
  "common.delete": "Supprimer",
  "common.back": "Retour",
  "common.open": "Ouvrir",
  "common.search": "Rechercher",
  "common.signIn": "Connexion",
  "common.signOut": "Déconnexion",
  "common.signInGoogle": "Connexion avec Google",
  "common.downloadPuls": "Télécharger PULS",
  "common.downloadPulsBody": "Continuez dans le viewer web ou téléchargez l'application pour l'enregistrement complet, les notifications et la participation.",
  "common.permissionDenied": "Accès refusé",
  "common.notFound": "Introuvable",
  "common.noDataYet": "Aucune donnée pour le moment",
  "common.viewActions": "Voir les actions",
  "common.viewLocation": "Position",
  "common.refreshLater": "Réessayez dans un instant.",
  "common.noDate": "Sans date",
  "common.status": "Statut",
  "common.confirm": "Confirmer",

  "app.subtitle": "Portail web PULS V2",
  "app.routeLoadingTitle": "Chargement de PULS...",
  "app.routeLoadingBody": "Cette section s'ouvre maintenant.",

  "auth.title": "Connexion à PULS",
  "auth.body": "Connectez-vous avec Google pour ouvrir le portail web. Le mode invité n'est pas disponible.",
  "auth.loading": "Vérification de la session...",
  "auth.signingIn": "Connexion...",
  "auth.error": "La connexion a échoué. Vérifiez que la fenêtre popup n'est pas bloquée puis réessayez.",
  "auth.privacy": "Politique de confidentialité",
  "auth.deleteAccount": "Suppression du compte",
  "auth.guest": "Invité",
  "auth.fullAccess": "Connectez-vous pour l'accès complet",

  "nav.home": "Accueil",
  "nav.dashboard": "Dashboard",
  "nav.brevetActions": "Brevet / Actions",
  "nav.actions": "Actions",
  "nav.myActions": "Mes actions",
  "nav.routes": "Parcours",
  "nav.myRoutes": "Mes parcours",
  "nav.routeEditor": "Modifier / Créer",
  "nav.community": "Communauté",
  "nav.communityRoutes": "Parcours communautaires",
  "nav.segments": "Segments",
  "nav.segmentRankings": "Classements segments",
  "nav.tasks": "Tâches",
  "nav.invitations": "Invitations",
  "nav.sosHelp": "SOS / Aide",
  "nav.supportControl": "Support / Control",
  "nav.settings": "Paramètres",
  "nav.profile": "Profil",
  "nav.segmentDetail": "Détail du segment",
  "nav.results": "Résultats",
  "nav.liveBrevet": "Live Brevet",
  "nav.publicTracking": "Suivi public",
  "nav.actionDetails": "Détails de l'action",
  "nav.routeEditorFull": "Modifier / Créer un parcours",
  "nav.adminSection": "Administration",
  "nav.admin": "Admin panel",

  "dashboard.loadingTitle": "Chargement de PULS",
  "dashboard.loadingBody": "Vérification de la session.",
  "dashboard.publicTitle": "PULS Control Center",
  "dashboard.publicBody": "Vue publique des actions et liens partagés, avec dashboard personnel après connexion.",
  "dashboard.welcomeTitle": "Bienvenue sur PULS",
  "dashboard.welcomeBody":
    "Vous pouvez voir les actions publiques et les liens live. Connectez-vous avec Google pour les tâches personnelles, les parcours, l'organisation et le profil.",
  "dashboard.title": "Dashboard",
  "dashboard.subtitle": "Résumé des tâches, de vos actions, parcours et flux live.",
  "dashboard.newAction": "Nouvelle action",
  "dashboard.newRoute": "Nouveau parcours",
  "dashboard.openTasks": "Ouvrir les tâches",
  "dashboard.pendingTitle": "En attente / Tâches",
  "dashboard.pendingDescription": "Invitations, support/control et SOS qui demandent attention.",
  "dashboard.total": "Total",
  "dashboard.myActionsTitle": "Mes actions",
  "dashboard.myActionsDescription": "Actions à venir ou actives dont vous êtes l'organisateur.",
  "dashboard.myActionsEmpty": "Vous n'avez pas d'action à venir ou active.",
  "dashboard.myRoutesTitle": "Mes parcours",
  "dashboard.myRoutesDescription": "Parcours récents enregistrés ou importés depuis votre compte.",
  "dashboard.synced": "synchronisés",
  "dashboard.recent": "Récent",
  "dashboard.noRoutes": "Aucun parcours synchronisé pour le moment.",
  "dashboard.liveNowTitle": "Live maintenant",
  "dashboard.liveNowDescription": "Actions actives avec accès rapide à la vue live race.",
  "dashboard.liveNowEmpty": "Vous n'avez pas d'action active actuellement.",
  "dashboard.liveAccessEmpty": "Aucune action active avec accès live pour le moment.",
  "dashboard.openLive": "Ouvrir Live",
  "dashboard.shortcutsTitle": "Actions rapides",
  "dashboard.shortcutsDescription": "Outils fréquents pour l'organisation, les parcours et le compte.",
  "dashboard.importRoute": "Importer GPX/TCX/KML",
  "dashboard.sectionLoadError": "Cette section n'a pas pu être chargée.",

  "admin.title": "Admin panel",
  "admin.subtitle": "Vue professionnelle des actions, opérations live, tâches en attente et état système.",
  "admin.loadingTitle": "Vérification de l'accès",
  "admin.loadingBody": "Vérification des droits admin.",
  "admin.loadingDataTitle": "Chargement des données admin",
  "admin.loadingDataBody": "Lecture des résumés sûrs.",
  "admin.loadErrorTitle": "Chargement impossible",
  "admin.loadErrorBody": "Réessayez dans un instant.",
  "admin.partialError": "Certaines sections de gestion n'ont pas été chargées.",
  "admin.availabilityTitle": "Disponibilité des données admin",
  "admin.availabilityAllowed": "Autorisé",
  "admin.availabilityPartial": "Disponibilité partielle",
  "admin.availabilityBlocked": "Bloqué",
  "admin.availabilitySection": "Section",
  "admin.availabilityReason": "Raison",
  "admin.availabilityDetails": "Détails",
  "admin.availabilityErrors": "Libellés d'erreur",
  "admin.availabilityReasonOk": "Cette section s'est chargée avec les permissions actuelles.",
  "admin.availabilityPartialReason": "Une partie des données disponibles a été chargée.",
  "admin.availabilityBlockedReason": "Non autorisé par les règles actuelles.",
  "admin.availabilityRulesChangeRequired": "Changement de règles requis",
  "admin.availabilityLiveMirrors": "Miroirs live",
  "admin.availabilityLiveMirrorsLoaded": "{loaded}/{total} miroirs live d'actions chargés.",
  "admin.availabilityActions": "Actions",
  "admin.availabilityUsers": "Utilisateurs",
  "admin.availabilityPending": "Tâches en attente",
  "admin.availabilitySos": "SOS / Aide",
  "admin.availabilityCommunity": "Communauté",
  "admin.availabilityLive": "Problèmes live",
  "admin.accessDeniedTitle": "Vous n'avez pas accès à cette page.",
  "admin.accessDeniedBody": "Cette section est réservée aux comptes admin.",
  "admin.totalActions": "Actions totales",
  "admin.activeActions": "Live maintenant",
  "admin.upcomingActions": "À venir",
  "admin.openHelp": "SOS ouverts",
  "admin.communityRoutes": "Parcours communauté",
  "admin.communitySegments": "Segments communauté",
  "admin.users": "Utilisateurs",
  "admin.liveNow": "Live maintenant",
  "admin.liveNowDescription": "Actions actives avec accès rapide à la vue live race.",
  "admin.noLiveNow": "Aucune action n'est live actuellement.",
  "admin.pendingTitle": "En attente système",
  "admin.pendingDescription": "Invitations, support/control et SOS qui demandent attention.",
  "admin.pendingInvitations": "Invitations",
  "admin.pendingSupportControl": "Support/Control",
  "admin.openSos": "SOS",
  "admin.openTasks": "Total",
  "admin.recentActions": "Actions récentes",
  "admin.recentActionsDescription": "Actions récemment mises à jour avec accès rapide.",
  "admin.noActions": "Aucune action disponible.",
  "admin.noSearchResults": "Aucun résultat trouvé.",
  "admin.quickActions": "Actions rapides",
  "admin.quickActionsDescription": "Raccourcis pour les principaux workflows admin.",
  "admin.usersTitle": "Utilisateurs / Cyclistes",
  "admin.usersDescription": "Vue sûre du nom, du rôle et du statut sans champs privés.",
  "admin.userCard": "Fiche",
  "admin.cyclistCardTitle": "Fiche cycliste",
  "admin.basicInfo": "Infos de base",
  "admin.basicInfoBody": "Champs du compte qu'un admin peut consulter.",
  "admin.technicalInfo": "Infos techniques admin",
  "admin.technicalInfoBody": "Utile pour vérifier la participation live et le support.",
  "admin.databaseId": "Database ID",
  "admin.authUid": "Auth UID",
  "admin.copyId": "Copier l'ID",
  "admin.idCopied": "L'ID a été copié.",
  "admin.displayName": "Nom",
  "admin.email": "Email",
  "admin.createdAt": "Créé",
  "admin.action": "Action",
  "admin.role": "Rôle",
  "admin.status": "Statut",
  "admin.date": "Date",
  "admin.athleteNumber": "Numéro athlète",
  "admin.memberships": "Participations / Actions",
  "admin.membershipsBody": "Actions où cet utilisateur apparaît comme athlète, organisateur, support ou control.",
  "admin.liveNowUserBody": "Entrées live où cet utilisateur apparaît dans le miroir public.",
  "admin.liveIssueTitle": "Contrôle live",
  "admin.liveIssueBody": "Vérification rapide de la présence live et des données de support.",
  "admin.liveEntriesCount": "Entrées live",
  "admin.liveDelayedCount": "Ancien / offline",
  "admin.lastUpdate": "Dernière mise à jour",
  "admin.lastKnownEvent": "Dernière action",
  "admin.liveStatusLive": "Live maintenant",
  "admin.liveStatusStale": "Ancien",
  "admin.liveStatusOffline": "Offline",
  "admin.liveStatusUnknown": "Inconnu",
  "admin.noRecentLiveUpdate": "Aucune mise à jour récente",
  "admin.secondsAgo": "il y a {count} s",
  "admin.minutesAgo": "il y a {count} min",
  "admin.hoursAgo": "il y a {count} h",
  "admin.liveHintLive": "L'utilisateur se met à jour normalement.",
  "admin.liveHintStale": "Aucune mise à jour récente. Signal, batterie ou fonctionnement en arrière-plan peuvent être en cause.",
  "admin.liveHintOffline": "Aucun signal live actif n'a été trouvé pour cet utilisateur.",
  "admin.copyDebugInfo": "Copier le debug info",
  "admin.copyLocation": "Copier la position",
  "admin.openGoogleMaps": "Ouvrir dans Google Maps",
  "admin.debugCopied": "Debug info copié.",
  "admin.locationCopied": "Position copiée.",
  "admin.noLiveSignal": "Aucun signal live actif n'a été trouvé.",
  "admin.updateAge": "Âge de mise à jour",
  "admin.battery": "Batterie",
  "admin.dataSource": "Source de données",
  "admin.lastKnownLocation": "Dernière position connue",
  "admin.noLocationAvailable": "Aucune position disponible.",
  "admin.livePermissionFallback": "Les données live opérationnelles ne sont pas lisibles. Seules les données publiques disponibles sont affichées.",
  "admin.openLiveFocus": "Ouvrir le Live avec focus",
  "admin.liveProblemsTitle": "Problèmes live",
  "admin.liveProblemsBody": "Contrôle central des athlètes avec retard, sans signal ou SOS/Aide.",
  "admin.searchTitle": "Recherche admin",
  "admin.searchBody": "Rechercher un utilisateur, cycliste, action, problème live ou ID.",
  "admin.searchPlaceholder": "Nom, email, numéro athlète, UID, action, eventId...",
  "admin.searchClear": "Effacer la recherche",
  "admin.searchUsers": "Utilisateurs / Cyclistes",
  "admin.searchActions": "Actions",
  "admin.searchLiveProblems": "Problèmes live",
  "admin.searchQuickIds": "Correspondances ID rapides",
  "admin.searchNoResults": "Aucun résultat trouvé.",
  "admin.openCard": "Ouvrir la fiche",
  "admin.openAction": "Ouvrir l'action",
  "admin.editAction": "Modifier l'action",
  "admin.liveOk": "Live OK",
  "admin.liveProblemAll": "Tous",
  "admin.liveProblemHelp": "SOS / Aide",
  "admin.liveProblemStale": "Retard",
  "admin.liveProblemOffline": "Sans signal",
  "admin.liveProblemGrouped": "Par action",
  "admin.issueTypeSOS": "SOS",
  "admin.issueTypeHELP": "Aide",
  "admin.issueTypeUnknown": "Inconnu",
  "admin.openLive": "Ouvrir le Live",
  "admin.openUserCard": "Fiche cycliste",
  "admin.noLiveProblems": "Aucun problème live.",
  "admin.offlineDetectionPartial": "Il n'y a pas assez de données pour la détection offline.",
  "admin.userCardUnavailable": "Aucun user id sûr n'est disponible pour cette fiche.",
  "admin.unknownAthlete": "Participant",
  "admin.liveGroupCounts": "Live {live} · Retard {stale} · Sans signal {offline} · SOS {help}",
  "admin.noAvailableData": "Aucune donnée disponible.",
  "admin.recentRoutes": "Parcours récents",
  "admin.recentRoutesDeferred": "La lecture admin des parcours privés reste pour une étape sûre ultérieure.",
  "admin.recentRoutesDeferredBody": "Les parcours privés complets ne sont pas affichés dans cette étape.",
  "admin.usersPermissionTitle": "Vous n'avez pas le droit de voir les utilisateurs.",
  "admin.usersPermissionBody": "La fiche utilisateur ne peut pas être lue avec les permissions actuelles.",
  "admin.livePermissionDenied": "La consultation des données live de cet utilisateur n'est pas autorisée.",
  "admin.userNotFoundTitle": "Utilisateur introuvable",
  "admin.userNotFoundBody": "Aucune fiche utilisateur n'existe pour cet ID.",
  "admin.backToAdmin": "Retour Admin",
  "admin.noUsers": "Aucun résumé utilisateur disponible.",
  "admin.usersUnavailable": "La lecture des utilisateurs n'est pas disponible avec les règles actuelles.",
  "admin.userStatusActive": "actif",
  "admin.lastSeen": "Dernière présence",
  "admin.systemTitle": "État système",
  "admin.systemDescription": "Liens de contrôle pour Web V2, pages publiques et Android App Links.",
  "admin.policy": "Politique",
  "admin.systemServices": "Services",
  "admin.participants": "participants",
  "admin.statusDraft": "Brouillon",
  "admin.statusUpcoming": "À venir",
  "admin.statusOngoing": "En cours",
  "admin.statusCompleted": "Terminé",
  "admin.statusCancelled": "Annulé",
  "admin.statusDeleted": "Supprimé",
  "admin.eventTypeRace": "Course",
  "admin.eventTypeGroupRide": "Sortie de groupe",
  "admin.eventTypeTraining": "Entraînement",
  "admin.eventTypeCharity": "Caritatif",
  "admin.eventTypeTour": "Tour",
  "admin.eventTypeOther": "Autre action",

  "actions.title": "Tâches",
  "actions.subtitle": "Boîte personnelle pour invitations, support/control et SOS / Aide.",
  "actions.authSubtitle": "Les invitations, support/control et SOS nécessitent une connexion.",
  "actions.authBody": "Connectez-vous pour voir vos tâches personnelles PULS.",
  "actions.pending": "En attente",
  "actions.loadingAccount": "Chargement du compte",
  "actions.loadingAccountBody": "Vérification de la session.",
  "actions.loadingInboxBody": "Lecture des éléments en attente.",
  "actions.loadError": "Chargement impossible",
  "actions.emptyTitle": "Aucun élément en attente",
  "actions.invitationsTitle": "Invitations athlète",
  "actions.invitationsSubtitle": "Invitations à participer aux actions.",
  "actions.invitationsEmpty": "Aucune invitation athlète en attente.",
  "actions.supportTitle": "Support / Control",
  "actions.supportSubtitle": "Demandes de rôle envoyées par les organisateurs.",
  "actions.supportEmpty": "Aucune demande support/control en attente.",
  "actions.helpTitle": "SOS / Aide",
  "actions.helpSubtitle": "Demandes ouvertes attribuées à votre compte.",
  "actions.helpEmpty": "Aucune demande SOS / aide ouverte.",
  "actions.accept": "Accepter",
  "actions.decline": "Refuser",
  "actions.resolve": "Résoudre",
  "actions.openAction": "Ouvrir l'action",
  "actions.fromOrganizer": "Invitation de",
  "actions.organizer": "organisateur",
  "actions.recipient": "Destinataire",
  "actions.currentUser": "utilisateur actuel",
  "actions.created": "Créé",
  "actions.supportRequest": "L'organisateur {organizer} vous demande de prendre le rôle {role}.",
  "actions.from": "De",
  "actions.athlete": "Athlète",
  "actions.invitationAccepted": "L'invitation a été acceptée.",
  "actions.invitationDeclined": "L'invitation a été refusée.",
  "actions.requestAccepted": "La demande a été acceptée.",
  "actions.requestDeclined": "La demande a été refusée.",
  "actions.helpResolved": "La demande SOS / aide a été marquée comme résolue.",
  "actions.errorGeneric": "L'action n'a pas pu être terminée.",
  "actions.errorPermission": "Vous n'avez pas l'autorisation pour cette action.",
  "actions.errorIndex": "Cette requête nécessite un index Firestore. La page reste sûre et n'a modifié aucune donnée.",
  "actions.errorInvitationNotPending": "L'invitation n'est plus en attente.",
  "actions.errorInvitationNoAccess": "L'invitation n'appartient pas à l'utilisateur actuel.",
  "actions.errorCyclistProfile": "Le Brevet nécessite un numéro de registre athlète dans le profil.",
  "actions.errorEventFull": "L'action est complète.",
  "actions.errorRequestNotPending": "La demande n'est plus en attente.",
  "actions.errorRequestNoAccess": "La demande n'appartient pas à l'utilisateur actuel.",

  "status.pending": "En attente",
  "status.accepted": "Acceptée",
  "status.declined": "Refusée",
  "status.expired": "Expirée",
  "status.open": "Ouverte",
  "status.resolved": "Résolue",

  "role.support": "Support",
  "role.control": "Control",
  "role.organizer": "Organisateur",
  "role.organizer_pending": "Demande organisateur",
  "role.admin": "Admin",
  "role.cyclist": "Athlète",
  "help.withdrawal": "Abandon",

  "profile.title": "Profil",
  "profile.subtitle": "Votre espace personnel pour les actions, parcours, tâches en attente et informations de compte.",
  "profile.loading": "Chargement du profil",
  "profile.loadingBody": "Lecture des informations de votre compte.",
  "profile.signInRequired": "Connectez-vous pour voir votre profil",
  "profile.signInRequiredBody": "Le profil affiche uniquement vos propres données sûres, parcours et tâches en attente.",
  "profile.defaultName": "Athlète PULS",
  "profile.myCard": "Ma fiche",
  "profile.myCardBody": "Données de base de votre compte.",
  "profile.displayName": "Nom",
  "profile.settingsTitle": "Paramètres du profil",
  "profile.settingsBody": "Mettez à jour les informations publiques sûres affichées dans PULS.",
  "profile.displayNameLabel": "Nom affiché",
  "profile.photoUrlLabel": "Photo de profil",
  "profile.changePhoto": "Changer la photo",
  "profile.deletePhoto": "Supprimer la photo",
  "profile.choosePhotoFile": "Choisir un fichier",
  "profile.uploadingPhoto": "Téléversement de la photo...",
  "profile.photoUpdated": "Photo mise à jour.",
  "profile.photoDeleted": "Photo supprimée.",
  "profile.photoUploadError": "Impossible d'envoyer la photo.",
  "profile.photoDeleteError": "Impossible de supprimer la photo.",
  "profile.invalidPhotoFile": "Choisissez une image JPG, PNG ou WebP jusqu'à 5 Mo.",
  "profile.photoHiddenHelp": "La photo est envoyée dans PULS et l'URL n'est pas affichée comme texte sur votre profil.",
  "profile.saveProfile": "Enregistrer le profil",
  "profile.profileUpdated": "Profil mis à jour.",
  "profile.profileSaveError": "Impossible d'enregistrer le profil.",
  "profile.profilePermissionError": "Vous n'avez pas le droit de modifier ces informations.",
  "profile.privacyVisibility": "Confidentialité et visibilité",
  "profile.privacyVisibilityBody": "Contrôles pour ce qui apparaît sur votre fiche de profil publique.",
  "profile.publicProfile": "Profil public",
  "profile.publicProfileBody": "Active votre fiche de profil publique sur puls.gr.",
  "profile.showPerformancePublicly": "Afficher les performances publiquement",
  "profile.showPerformancePubliclyBody": "Indique que seules les statistiques public-safe pourront apparaître lorsqu'un modèle public sera disponible.",
  "profile.showRoutesPublicly": "Afficher les parcours publiquement",
  "profile.showRoutesPubliclyBody": "Indique que les parcours publics pourront apparaître lorsqu'un miroir public sûr sera activé.",
  "profile.enablePublicProfileFirst": "Activez d'abord le profil public pour choisir les sections publiques.",
  "profile.publicProfileLink": "Lien du profil public",
  "profile.copyProfileLink": "Copier le lien",
  "profile.profileLinkCopied": "Lien copié",
  "profile.publicProfileLoading": "Lecture de la fiche de profil publique.",
  "profile.publicProfileUnavailable": "Le profil public n'est pas disponible.",
  "profile.publicProfileUnavailableBody": "L'utilisateur n'a pas activé de profil public ou le lien est incorrect.",
  "profile.publicAthleteCard": "Fiche athlète publique",
  "profile.publicStatsPlaceholder": "Les statistiques publiques apparaîtront lorsque des données public-safe seront disponibles.",
  "profile.publicRoutesDeferred": "Les parcours publics seront activés dans une étape suivante.",
  "profile.preferredLanguage": "Langue préférée",
  "profile.localLanguageSetting": "Réglage local de la langue dans ce navigateur.",
  "profile.futureOption": "Sera activé dans une étape suivante.",
  "profile.liveSharingVisibility": "Le partage live est visible par toute personne ayant le lien.",
  "profile.resultsVisibilityNote": "Les résultats des actions peuvent apparaître publiquement avec des champs sûrs.",
  "profile.email": "Email",
  "profile.providers": "Fournisseur de connexion",
  "profile.language": "Langue",
  "profile.roles": "Rôles",
  "profile.rolesBody": "Les rôles viennent de votre compte et de vos actions.",
  "profile.myActions": "Mes actions",
  "profile.myActionsBody": "Actions où vous êtes organisateur, participant, support ou control.",
  "profile.openActions": "Ouvrir les actions",
  "profile.myRoutes": "Mes parcours",
  "profile.myRoutesBody": "Parcours récents enregistrés et importés.",
  "profile.openRoutes": "Ouvrir les parcours",
  "profile.openRouteEditor": "Modifier / Créer",
  "profile.myTasks": "Mes tâches",
  "profile.myTasksBody": "Invitations, demandes support/control et SOS en attente.",
  "profile.openTasks": "Ouvrir les tâches",
  "profile.myPerformance": "Mes performances",
  "profile.myPerformanceBody": "Statistiques personnelles réelles à partir de vos parcours enregistrés.",
  "profile.performanceFilter": "Filtre de performance",
  "profile.filterAll": "Tous",
  "profile.profileBicycle": "Vélo",
  "profile.profileElectricBike": "Vélo électrique",
  "profile.profileHiking": "Randonnée",
  "profile.profileMotorVehicle": "Motorisé",
  "profile.profileOther": "Autre / ancien",
  "profile.totalRoutes": "Parcours",
  "profile.totalTime": "Temps total",
  "profile.averageSpeed": "Vitesse moyenne",
  "profile.maxSpeed": "Vitesse max",
  "profile.distanceByMonth": "Distance par mois",
  "profile.elevationByMonth": "Dénivelé par mois",
  "profile.activitiesByMonth": "Activités par mois",
  "profile.personalRecords": "Records personnels",
  "profile.mostElevation": "Plus grand dénivelé",
  "profile.bestAverageSpeed": "Meilleure vitesse moyenne",
  "profile.longestDuration": "Durée la plus longue",
  "profile.recentActivities": "Activités récentes",
  "profile.openRecord": "Ouvrir",
  "profile.noPerformanceData": "Aucune donnée pour ce filtre.",
  "profile.privacyAccount": "Confidentialité et compte",
  "profile.privacyBody": "Liens vers la politique de confidentialité et la suppression du compte.",
  "profile.publicLinksNote": "Les liens live publics sont visibles par toute personne ayant le lien.",
  "profile.privacyPolicy": "Politique de confidentialité",
  "profile.accountDeletion": "Suppression du compte",
  "profile.recentRoutes": "Parcours récents",
  "profile.pending": "En attente",
  "profile.totalDistance": "Distance totale",
  "profile.longestRoute": "Parcours le plus long",
  "profile.totalElevation": "Dénivelé total",
  "profile.recentActivity": "Activité récente",
  "profile.noData": "Aucune donnée pour le moment",
  "profile.invitations": "Invitations",
  "profile.supportControl": "Support / Control",
  "profile.helpSos": "SOS / Aide",
  "profile.profileLoadError": "Impossible de charger votre fiche profil.",
  "profile.routesLoadError": "Impossible de charger vos parcours.",
  "profile.actionsLoadError": "Impossible de charger vos actions.",
  "profile.pendingLoadError": "Impossible de charger les tâches en attente.",
  "profile.readOnlyProfile": "La modification du profil sera ajoutée séparément lorsque le modèle d'écriture sûr sera finalisé.",

  "events.title": "Actions",
  "events.myTitle": "Mes actions",
  "events.subtitle": "Consultation publique des actions. Le mode de participation contrôle l'inscription, pas la visibilité.",
  "events.mySubtitle": "Uniquement les actions où vous êtes organisateur, participant, support ou control.",
  "events.newAction": "Nouvelle action",
  "events.invitationsRequests": "Invitations & demandes",
  "events.loadingTitle": "Chargement des actions",
  "events.loadingPublic": "Lecture des actions publiques.",
  "events.loadingMine": "Lecture de vos actions.",
  "events.loadErrorTitle": "Chargement impossible",
  "events.loadErrorBody": "Réessayez dans un instant. Cette page ne modifie aucune donnée.",
  "events.emptyPublicTitle": "Aucune action disponible",
  "events.emptyMineTitle": "Aucune action pour vous",
  "events.emptyPublicBody": "Les actions supprimées, brouillons ou annulées ne sont pas affichées dans la liste publique.",
  "events.emptyMineBody": "Les actions où vous êtes organisateur, participant, support ou control apparaîtront ici.",
  "events.photo": "Photo de l'action",
  "events.noLocation": "Aucune position définie",
  "events.registrationDeadline": "Date limite",
  "events.untilStart": "jusqu'au départ",
  "events.participants": "participants",

  "routes.title": "Mes parcours",
  "routes.subtitle": "Parcours synchronisés depuis l'application, avec les parcours communautaires importés.",
  "routes.authSubtitle": "Parcours personnels et importés depuis l'application.",
  "routes.count": "{count} parcours",
  "routes.loadingAccount": "Vérification de la session",
  "routes.loadingAccountBody": "Lecture du compte.",
  "routes.signInRequired": "Connexion requise",
  "routes.signInRequiredBody": "Connectez-vous pour voir vos parcours enregistrés.",
  "routes.loadingTitle": "Chargement des parcours",
  "routes.loadingBody": "Lecture de votre synchronisation Firestore personnelle.",
  "routes.loadErrorTitle": "Chargement impossible",
  "routes.loadErrorBody": "Vérifiez que vous êtes connecté avec le même compte que l'application.",
  "routes.emptyTitle": "Aucun parcours synchronisé",
  "routes.emptyBody": "Les parcours apparaissent ici après enregistrement/synchronisation depuis l'application Android ou l'éditeur web.",
  "routes.recordedSection": "Enregistrés dans l'application",
  "routes.importedSection": "Parcours importés",
  "routes.imported": "Importé",
  "routes.own": "À moi",
  "routes.points": "points",
  "routes.routePoints": "points du parcours",
  "routes.profileBicycle": "Vélo",
  "routes.profileElectricBike": "Vélo électrique",
  "routes.profileHiking": "Marche / randonnée",
  "routes.profileMotorVehicle": "Motorisé",
  "routes.profileLegacy": "Legacy / sans profil",

  "detail.actionDetails": "Détails de l'action",
  "detail.publicAction": "Vue publique de l'action.",
  "detail.legacyAction": "Lien compatible /event/:eventId dans le nouveau Web V2.",
  "detail.participants": "Participants",
  "detail.invitations": "Invitations",
  "detail.supportControl": "Support / Control",
  "detail.results": "Résultats",
  "detail.editRoute": "Modifier le parcours",
  "detail.editAction": "Modifier l'action",
  "detail.useSavedRoute": "Choisir depuis Mes parcours",

  "public.live": "Live",
  "public.inactive": "Inactif",
  "public.stale": "Ancien",
  "public.speed": "Vitesse",
  "public.average": "Moyenne",
  "public.max": "Max",
  "public.distance": "Distance",
  "public.duration": "Durée",
  "public.elevation": "Dénivelé",
  "public.altitude": "Altitude",
  "public.points": "Points",
  "public.lastUpdate": "Dernière mise à jour",
  "public.liveMap": "Carte live",
  "public.missingLink": "Le lien est incomplet",
  "public.missingEvent": "Aucun identifiant d'action dans ce lien.",
  "public.missingSession": "Aucun identifiant de session live dans ce lien.",
  "public.trackShareTools": "Partager la position live",
  "public.trackShareToolsBody": "Copiez un texte sûr ou un lien social avec aperçu, sans coordonnées exactes.",
  "public.trackShareTitle": "📍 Position en direct PULS",
  "public.trackShareBody": "{name} partage sa position en direct.",
  "public.trackShareOpen": "Ouvrir le suivi en direct :",
  "public.trackShareDownload": "Téléchargez PULS :",

  "liveControl.title": "Live Race Control Room",
  "liveControl.publicAccess": "Vue publique",
  "liveControl.signedInAccess": "Utilisateur connecté",
  "liveControl.checkingAccess": "Vérification de l'accès",
  "liveControl.adminAccess": "Control room admin",
  "liveControl.organizerAccess": "Organisateur",
  "liveControl.supportAccess": "Support",
  "liveControl.controlAccess": "Control",
  "liveControl.privateDeniedTitle": "Control room privé",
  "liveControl.privateDeniedBody": "La liste privée des athlètes live nécessite un accès organisateur/support/control. La vue publique continue depuis le miroir public.",
  "liveControl.noMirrorTitle": "Aucun miroir live public pour le moment",
  "liveControl.noMirrorBody": "L'action est chargée depuis Firestore, mais aucun athlète live n'est encore disponible dans le miroir public RTDB.",
  "liveControl.closedTitle": "Le suivi live est terminé",
  "liveControl.closedBody": "L'action est terminée ou annulée, les positions des athlètes ne sont donc plus affichées.",
  "liveControl.publicLoadError": "Le live public n'a pas pu être lu. Aucune donnée n'a été modifiée.",
  "liveControl.totalAthletes": "Total athlètes",
  "liveControl.liveAthletes": "Athlètes live",
  "liveControl.staleAthletes": "Ancien",
  "liveControl.openHelp": "SOS ouverts",
  "liveControl.located": "localisés",
  "liveControl.athletes": "Athlètes",
  "liveControl.athletesBody": "Recherche, filtres et focus carte.",
  "liveControl.searchAthlete": "Rechercher nom ou numéro",
  "liveControl.filterALL": "Tous",
  "liveControl.filterLIVE": "Live",
  "liveControl.filterSTALE": "Ancien",
  "liveControl.filterSOS": "SOS",
  "liveControl.filterDONE": "Terminés / Abandons",
  "liveControl.noAthletes": "Aucun athlète pour ce filtre.",
  "liveControl.live": "Live",
  "liveControl.stale": "Ancien",
  "liveControl.offline": "Offline",
  "liveControl.paused": "Pause",
  "liveControl.finished": "Terminé",
  "liveControl.withdrawn": "Abandon",
  "liveControl.battery": "Batterie",
  "liveControl.hasHelp": "SOS / Aide",
  "liveControl.mapTitle": "Carte de contrôle live",
  "liveControl.mapBody": "Athlètes, parcours et points Roadbook sur une seule carte.",
  "liveControl.mapLoadError": "La carte n'a pas pu être chargée.",
  "liveControl.followingAthlete": "Focus : {name}",
  "liveControl.athleteNotFound": "L'athlète n'est pas en live actuellement.",
  "liveControl.fitAll": "Tout afficher",
  "liveControl.clearSelection": "Effacer la sélection",
  "liveControl.helpTitle": "SOS / Aide",
  "liveControl.helpBody": "Demandes ouvertes qui vous sont assignées.",
  "liveControl.helpPublicBody": "Les SOS opérationnels sont visibles uniquement par organisateur/support/control.",
  "liveControl.helpLoading": "Chargement SOS / Aide...",
  "liveControl.helpError": "Impossible de charger ou mettre à jour les SOS.",
  "liveControl.noHelp": "Aucune demande SOS / aide ouverte.",
  "liveControl.dataSourceTitle": "Source de données",
  "liveControl.publicDataSource": "La vue publique utilise public_live_events et n'affiche aucun champ privé.",
  "liveControl.operationalDataSource": "Le control room utilise le miroir live public et, si autorisé, l'accès privé live_events.",
  "liveControl.privacyTitle": "Privacy-safe",
  "liveControl.privacyBody": "Téléphone, email, contacts d'urgence et identifiants user bruts ne sont pas affichés.",
  "liveControl.doneSummary": "{count} athlètes ont terminé ou abandonné.",

  "routeEditor.title": "Modifier / Créer un parcours",
  "routeEditor.import": "Importer un fichier",
  "routeEditor.routeMode": "Parcours",
  "routeEditor.poiMode": "Points d'intérêt",
  "routeEditor.start": "Départ",
  "routeEditor.finish": "Arrivée",
  "routeEditor.waypoint": "Point intermédiaire",
  "routeEditor.save": "Enregistrer",
  "routeEditor.update": "Mettre à jour le parcours",
  "routeEditor.copy": "Enregistrer une copie",
  "routeEditor.undo": "Annuler",
  "routeEditor.clear": "Effacer",
  "routeEditor.discard": "Ignorer",
  "routeEditor.draftRecovery": "Récupération du brouillon",
  "routeEditor.collapseTools": "Réduire les outils",
  "routeEditor.openTools": "Ouvrir les outils",
  "routeEditor.fullMap": "Carte complète",
  "routeEditor.showTools": "Afficher les outils",
  "routeEditor.shortcuts": "Raccourcis",
  "routeEditor.shortcutsHint": "Raccourcis : Ctrl+Z annuler, Esc annuler l'outil.",
  "routeEditor.cancelTool": "Annuler l'outil",
  "routeEditor.sectionImport": "Importer un fichier",
  "routeEditor.sectionRoute": "Parcours",
  "routeEditor.sectionCorrection": "Outils de correction",
  "routeEditor.sectionMarkers": "Points du parcours",
  "routeEditor.sectionRoadbook": "Roadbook",
  "routeEditor.sectionSave": "Enregistrer",
  "routeEditor.kmTools": "Outils kilométriques",
  "routeEditor.type": "Type",
  "routeEditor.titleField": "Titre",
  "routeEditor.descriptionField": "Description",
  "routeEditor.moveToKm": "Déplacer au km",
  "routeEditor.visibleToAthletes": "Visible pour les athlètes",
  "routeEditor.localMarkers": "marqueurs locaux dans l'espace de travail",
  "routeEditor.kmAutoHint": "Le km est mis à jour automatiquement quand le point est placé près du parcours.",
  "routeEditor.correctionTools": "Outils de correction",
  "routeEditor.correctionToolsHint": "Inversez, coupez ou nettoyez prudemment la ligne avant l'enregistrement.",
  "routeEditor.reverseRoute": "Inverser le parcours",
  "routeEditor.trimStart": "Couper le départ",
  "routeEditor.trimFinish": "Couper l'arrivée",
  "routeEditor.cleanRoute": "Nettoyer le parcours",
  "routeEditor.trimToolHint": "Cliquez sur le parcours pour choisir un point.",
  "routeEditor.routeRequiredForCorrection": "Calculez ou importez d'abord un parcours.",
  "routeEditor.correctionRouteTooShort": "Le parcours serait trop court après cette correction.",
  "routeEditor.trimPointTooFar": "Le point est loin du parcours.",
  "routeEditor.routeReversed": "Le parcours a été inversé.",
  "routeEditor.routeTrimmedStart": "Le début du parcours a été coupé.",
  "routeEditor.routeTrimmedFinish": "La fin du parcours a été coupée.",
  "routeEditor.routeCleaned": "Parcours nettoyé. {count} points supprimés.",
  "routeEditor.routeAlreadyClean": "Aucun point problématique n'a été trouvé.",
  "routeEditor.markerFarWarning": "Certains points d'intérêt sont loin du nouveau parcours.",
  "routeEditor.unifiedSearchLabel": "Rechercher",
  "routeEditor.unifiedSearchPlaceholder": "Rechercher un lieu ou un point du parcours",
  "routeEditor.placesGroup": "Lieux",
  "routeEditor.routePointsGroup": "Points du parcours",
  "routeEditor.noSearchResults": "Aucun résultat trouvé",
  "routeEditor.selectTargetFirst": "Choisissez d'abord une cible pour le lieu",
  "routeEditor.target": "Cible",
  "routeEditor.placesMinChars": "Les suggestions de lieux apparaissent après 5 caractères.",
  "routeEditor.placesLoading": "Chargement des suggestions...",
  "routeEditor.placeSelectError": "Le lieu n'a pas pu être sélectionné.",
  "routeEditor.markerListHint": "Les points sont filtrés par la recherche commune ci-dessus.",
  "routeEditor.routePointSuggestions": "Suggestions de points",
  "routeEditor.elevationCalculating": "Calcul des altitudes...",
  "routeEditor.elevationFailed": "Le calcul des altitudes a échoué.",
  "routeEditor.elevationRetry": "Réessayer",
  "routeEditor.saveWithoutElevation": "Enregistrer sans altitude",
  "routeEditor.exportGpx": "Exporter GPX",
  "routeEditor.gpxCreating": "Création du GPX...",
  "routeEditor.noRouteToExport": "Aucun parcours à exporter.",
  "routeEditor.gpxExportSuccess": "Le GPX a été créé pour le téléchargement.",
  "routeEditor.gpxExportFailed": "Impossible d'exporter le GPX.",
  "routeEditor.noElevationWarning": "Le parcours n'a pas de données d'altitude.",
  "routeEditor.exportWithoutElevationHint": "Enregistrez d'abord pour calculer les altitudes, ou exportez sans altitude.",
  "routeEditor.exportWithoutElevation": "Exporter sans altitude",
  "routeEditor.gpxIncludesElevation": "L'export GPX inclut les altitudes.",
  "routeEditor.saveSuccessWithTime": "Enregistré avec succès. Dernier enregistrement : {time}",
  "routeEditor.saveFailed": "Le parcours n'a pas pu être enregistré.",
  "routeEditor.updateFailed": "Le parcours n'a pas pu être mis à jour.",

  "common.close": "Fermer",
  "common.points": "points",
  "common.routePoints": "points du parcours",
  "common.saving": "Enregistrement...",
  "common.replacing": "Remplacement",
  "common.unknown": "Inconnu",

  "eventType.BREVET": "Brevet",
  "eventType.RACE": "Course",
  "eventType.GROUPRIDE": "Sortie de groupe",
  "eventType.TRAINING": "Entraînement",
  "eventType.CHARITY": "Caritatif",
  "eventType.TOUR": "Tour",
  "eventType.OTHER": "Autre action",
  "eventStatus.UPCOMING": "À venir",
  "eventStatus.ONGOING": "En cours",
  "eventStatus.COMPLETED": "Terminée",
  "eventStatus.DRAFT": "Brouillon",
  "eventStatus.CANCELLED": "Annulée",
  "eventStatus.CANCELED": "Annulée",
  "participationMode.OPEN": "Participation ouverte",
  "participationMode.APPROVAL_REQUIRED": "Sur approbation",
  "participationMode.INVITE_ONLY": "Sur invitation",

  "preview.defaultTitle": "Aperçu",
  "preview.actionPhoto": "Photo de l'action",
  "preview.noVisual": "Aucune photo ou prévisualisation du parcours n'est encore disponible.",

  "routeMarkers.title": "Points du parcours",
  "routeMarkers.emptyPublic": "Aucun point public n'a été ajouté au parcours.",
  "routeMarkers.loading": "Chargement des points du parcours...",
  "routeMarkers.loadError": "Les points du parcours n'ont pas pu être chargés.",
  "routeMarkers.pointOfInterest": "Point d'intérêt",

  "elevationProfile.title": "Profil d'altitude",
  "elevationProfile.notEnoughData": "Il n'y a pas assez de points avec altitude pour afficher un graphique.",

  "savedRoute.mapTitle": "Carte du parcours",
  "savedRoute.mapDescription": "Vue complète du parcours avec départ, arrivée et points d'intérêt.",
  "savedRoute.largeMap": "Grande carte",
  "savedRoute.largeMapDescription": "Grande carte du parcours.",
  "savedRoute.mapLoadError": "La carte n'a pas pu être chargée. Le parcours est affiché en aperçu simple.",
  "savedRoute.routeHighlightsTitle": "Points clés du parcours",
  "savedRoute.routeHighlightsBody": "Points importants issus de l'enregistrement sauvegardé.",
  "savedRoute.noRouteHighlights": "Il n'y a pas assez de données pour les points clés.",
  "savedRoute.maxSpeedPoint": "Vitesse maximale",
  "savedRoute.maxAltitudePoint": "Altitude maximale",
  "savedRoute.focusMap": "Centrer sur la carte",
  "savedRoute.kmAlongRoute": "Km du parcours",
  "savedRoute.time": "Heure",
  "savedRoute.altitude": "Altitude",
  "savedRoute.climbsTitle": "Montées possibles",
  "savedRoute.climbsBody": "Détection locale de montée avec une logique équivalente à l'application Android.",
  "savedRoute.climbsCount": "{count} possibles",
  "savedRoute.climbLabel": "Montée possible {index}",
  "savedRoute.viewOnMap": "Voir sur la carte",
  "savedRoute.noClimbs": "Aucune montée possible n'a été détectée sur ce parcours.",
  "savedRoute.climbsUnsupported": "La détection des montées ne s'applique pas à ce type de parcours.",
  "savedRoute.from": "De",
  "savedRoute.to": "À",
  "savedRoute.elevationGain": "Dénivelé positif",
  "savedRoute.averageGrade": "Pente moyenne",
  "savedRoute.climbStart": "Début de montée",
  "savedRoute.climbFinish": "Fin de montée",
  "savedRoute.hours": "Horaires",
  "savedRoute.water": "Eau",
  "savedRoute.food": "Ravitaillement",
  "savedRoute.coffee": "Pause / Café",
  "savedRoute.warning": "Attention",
  "savedRoute.service": "Assistance",
  "savedRoute.photo": "Photo",
  "savedRoute.note": "Note",
  "savedRoute.personalDescription": "Parcours personnel enregistré depuis l'application ou l'éditeur web.",
  "savedRoute.edit": "Modifier",
  "savedRoute.openInEditor": "Ouvrir dans l'éditeur",
  "savedRoute.useInAction": "Utiliser dans une action",
  "savedRoute.downloadGpx": "Télécharger GPX",
  "savedRoute.missingTitle": "Parcours manquant",
  "savedRoute.missingBody": "Ce lien ne contient pas d'identifiant ride.",
  "savedRoute.loadingTitle": "Chargement du parcours",
  "savedRoute.loadingBody": "Lecture du parcours personnel.",
  "savedRoute.loadErrorTitle": "Chargement impossible",
  "savedRoute.loadErrorBody": "Le parcours n'a pas pu être lu depuis votre Firestore personnel.",
  "savedRoute.notFoundTitle": "Parcours introuvable",
  "savedRoute.notFoundBody": "Il a peut-être été supprimé ou appartient à un autre compte.",
  "savedRoute.authBody": "Connectez-vous pour voir vos parcours personnels enregistrés.",
  "savedRoute.poiTitle": "Points d'intérêt / control",
  "savedRoute.poiBody": "Points enregistrés avec le parcours.",
  "savedRoute.noPoi": "Aucun point d'intérêt enregistré.",
  "savedRoute.activityChangeType": "Changer le type d'activité",
  "savedRoute.activityChangeTypeBody": "Choisissez le bon type sans modifier la géométrie, les points GPS ou les statistiques du parcours.",
  "savedRoute.activityExcludeFromRecords": "Exclure des records personnels",
  "savedRoute.activityIncludeInRecords": "Inclure dans les records personnels",
  "savedRoute.activityExcludeConfirmBody": "Le parcours restera enregistré, mais il ne comptera plus dans vos meilleurs résultats, vos records personnels ou vos tentatives de segment.",
  "savedRoute.activityIncludeConfirmBody": "Le parcours pourra de nouveau compter dans les statistiques personnelles, s'il n'est pas encore suspect ou incompatible avec son type.",
  "savedRoute.activitySuspiciousTitle": "Activité suspecte",
  "savedRoute.activitySuspiciousBody": "Ce parcours semble incompatible avec le type d'activité sélectionné. Corrigez le type ou excluez-le des records.",
  "savedRoute.activityExcludedTitle": "Exclu des records personnels",
  "savedRoute.activityExcludedBody": "Le parcours reste enregistré, mais il ne compte pas dans vos meilleurs résultats ni dans les tentatives de segment.",
  "savedRoute.activityKeepAsIs": "Conserver tel quel",
  "savedRoute.activityTypeUpdated": "Le type d'activité a été mis à jour.",
  "savedRoute.activityExcludedFromRecords": "Le parcours a été exclu des records.",
  "savedRoute.activityIncludedInRecords": "Le parcours peut de nouveau compter dans les records.",
  "savedRoute.activityKeptAsIs": "Le parcours a été confirmé tel quel.",
  "savedRoute.activityUpdateFailed": "Le parcours n'a pas pu être mis à jour.",
  "savedRoute.activityFlagHikingSpeedHigh": "La randonnée a une vitesse anormalement élevée.",
  "savedRoute.activityFlagBicycleSpeedHigh": "Le vélo a une vitesse anormalement élevée.",
  "savedRoute.activityFlagEbikeSpeedHigh": "Le vélo électrique a une vitesse anormalement élevée.",
  "savedRoute.activityFlagCarLikeSpeed": "Le parcours ressemble à un déplacement motorisé.",
  "savedRoute.activityFlagTeleportJump": "Il peut y avoir un saut GPS ou un segment irréaliste.",
  "savedRoute.activityFlagGeneric": "Le parcours doit être vérifié.",
  "savedRoute.stats": "Statistiques",
  "savedRoute.summary": "Résumé des points du parcours",
  "savedRoute.routePoints": "Points du parcours",
  "savedRoute.controlPoiPoints": "Points Control / POI",
  "savedRoute.firstPoint": "Premier point",
  "savedRoute.lastPoint": "Dernier point",
  "savedRoute.file": "Fichier",
  "savedRoute.createSegment": "Créer segment",
  "savedRoute.segmentCreateTitle": "Créer un segment depuis une montée",
  "savedRoute.segmentCreateBody": "Ajustez le départ/l'arrivée, nommez-le et enregistrez le segment dans la Communauté.",
  "savedRoute.defaultSegmentTitle": "Montée {from}-{to} km",
  "savedRoute.segmentName": "Nom du segment",
  "savedRoute.segmentDescription": "Description",
  "savedRoute.segmentProfile": "Profil",
  "savedRoute.segmentStartKm": "Départ (km)",
  "savedRoute.segmentFinishKm": "Arrivée (km)",
  "savedRoute.selectStartEndpoint": "Changer départ",
  "savedRoute.selectFinishEndpoint": "Changer arrivée",
  "savedRoute.endpointStart": "départ",
  "savedRoute.endpointFinish": "arrivée",
  "savedRoute.segmentAdjustHint": "Point actif : {endpoint}. Cliquez la ligne bleue du parcours ou modifiez les km.",
  "savedRoute.segmentInvalidEndpoints": "Le départ doit précéder l'arrivée et inclure assez de points.",
  "savedRoute.segmentTooShort": "Le segment doit mesurer au moins 100 m.",
  "savedRoute.segmentTitleRequired": "Saisissez un nom de segment.",
  "savedRoute.segmentUnsupportedProfile": "Ce profil n'est pas pris en charge pour les segments.",
  "savedRoute.segmentSaving": "Enregistrement...",
  "savedRoute.saveSegment": "Enregistrer segment",
  "savedRoute.segmentSaveSuccess": "Le segment a été enregistré et apparaîtra dans Segments.",
  "savedRoute.segmentSaveFailed": "Le segment n'a pas pu être enregistré.",
  "savedRoute.openSegments": "Ouvrir Segments",
  "stats.distance": "Distance",
  "stats.duration": "Durée",
  "stats.average": "Moyenne",
  "stats.max": "Max",
  "stats.elevationGain": "Dénivelé +",
  "stats.elevationLoss": "Dénivelé -",
  "stats.minAltitude": "Altitude min",
  "stats.maxAltitude": "Altitude max",
  "stats.points": "Points",

  "attachRoute.title": "Associer un parcours à une action",
  "attachRoute.description": "Le parcours sera téléversé en GPX et mettra à jour l'aperçu de l'action.",
  "attachRoute.chooseAction": "Choisir une action",
  "attachRoute.action": "Action",
  "attachRoute.chooseRoute": "Choisir un parcours",
  "attachRoute.route": "Parcours",
  "attachRoute.loadingActions": "Chargement des actions...",
  "attachRoute.loadingRoutes": "Chargement des parcours...",
  "attachRoute.noEditableActions": "Aucune action modifiable n'a été trouvée.",
  "attachRoute.noRoutes": "Aucun parcours enregistré avec des points valides n'a été trouvé.",
  "attachRoute.replaceWarning": "Cette action a déjà un parcours. Je veux le remplacer par le parcours sélectionné.",
  "attachRoute.transferMarkers": "Transférer les points du parcours vers l'action",
  "attachRoute.transferMarkersAvailable": "ajouter sans supprimer les points existants",
  "attachRoute.transferMarkersUnavailable": "ce parcours n'a pas de points",
  "attachRoute.submit": "Associer le parcours",
  "attachRoute.submitting": "Association...",
  "attachRoute.success": "Le parcours a été associé à l'action.",
  "attachRoute.successWithMarkers": "Le parcours a été associé à l'action et {count} points ont été ajoutés.",
  "attachRoute.loadActionsError": "Impossible de charger les actions que vous pouvez modifier.",
  "attachRoute.loadRoutesError": "Impossible de charger vos parcours.",
  "attachRoute.permissionError": "Vous n'avez pas l'autorisation de modifier cette action ou de téléverser ce parcours.",
  "attachRoute.routePointsRequired": "Le parcours n'a pas assez de points pour être associé à une action.",
  "attachRoute.genericError": "Le parcours n'a pas pu être associé à l'action.",
  "actionForm.createTitle": "Nouvelle action",
  "actionForm.editTitle": "Modifier l'action",
  "actionForm.subtitle": "Toutes les actions sont visibles publiquement. Le mode de participation contrôle seulement qui peut s'inscrire.",
  "actionForm.createPill": "Créer",
  "actionForm.editPill": "Modifier",
  "actionForm.basic": "Informations de base",
  "actionForm.title": "Titre",
  "actionForm.description": "Description",
  "actionForm.actionType": "Type d'action",
  "actionForm.status": "Statut",
  "actionForm.targetSpeed": "Moyenne/cible km/h",
  "actionForm.photoUrl": "URL photo optionnelle",
  "actionForm.time": "Horaires",
  "actionForm.start": "Début",
  "actionForm.end": "Fin",
  "actionForm.durationHours": "Durée en heures",
  "actionForm.registrationDeadline": "Date limite d'inscription",
  "actionForm.startLocation": "Lieu de départ",
  "actionForm.locationName": "Nom du lieu",
  "actionForm.participation": "Participation",
  "actionForm.maxParticipants": "Participants max",
  "actionForm.participationMode": "Mode de participation",
  "actionForm.allowParticipantLiveMap": "Autoriser la carte live des participants lorsque disponible.",
  "actionForm.route": "Parcours",
  "actionForm.routeDescription": "Vous pouvez laisser l'action sans parcours ou choisir un de vos parcours enregistrés.",
  "actionForm.existingRouteWarning": "Cette action a déjà un parcours. Un nouveau choix le remplacera après confirmation.",
  "actionForm.noRouteChange": "Aucun changement de parcours",
  "actionForm.noRouteChangeBody": "L'action restera sans nouveau parcours ou conservera le parcours actuel.",
  "actionForm.replaceRouteConfirm": "Cette action a déjà un parcours. Je veux le remplacer.",
  "actionForm.transferMarkers": "Transférer les points du parcours vers l'action en ajout.",
  "actionForm.checkDetails": "Vérifiez les informations",
  "actionForm.saveAction": "Enregistrer l'action",
  "actionForm.cancel": "Annuler",
  "actionForm.loadingAction": "Chargement de l'action",
  "actionForm.loadingActionBody": "Lecture depuis Firestore.",
  "actionForm.signInBody": "Connectez-vous pour créer ou modifier une action.",
  "actionForm.editNotAllowedTitle": "Modification non autorisée",
  "actionForm.editNotAllowedBody": "Pour l'instant, la modification web est affichée uniquement à l'organisateur de l'action.",
  "actionForm.notFoundTitle": "Action introuvable",
  "actionForm.notFoundBody": "Aucune action modifiable n'est disponible pour ce lien.",
  "actionForm.saved": "L'action a été enregistrée.",
  "actionForm.savedLink": "L'action a été enregistrée : /event/{eventId}",
  "actionForm.routeAttachPartialWarning": "L'action a été enregistrée, mais le parcours n'a pas été associé. Vous pouvez l'associer depuis le détail de l'action.",
  "actionForm.loadRoutesError": "Impossible de charger vos parcours.",
  "actionForm.loadActionError": "Impossible de charger l'action.",
  "actionForm.permissionError": "Vous n'avez pas l'autorisation d'enregistrer cette action.",
  "actionForm.saveError": "L'action n'a pas pu être enregistrée.",
  "actionForm.errorTitleRequired": "Le titre est obligatoire.",
  "actionForm.errorStartRequired": "La date de début est obligatoire.",
  "actionForm.errorEndAfterStart": "La fin doit être après le début.",
  "actionForm.errorDeadlineBeforeStart": "La date limite d'inscription doit être avant le début.",
  "actionForm.errorDuration": "La durée doit être d'au moins 1 heure.",
  "actionForm.errorParticipants": "Le nombre de participants doit être positif.",
  "actionForm.errorLatitude": "La latitude doit être entre -90 et 90.",
  "actionForm.errorLongitude": "La longitude doit être entre -180 et 180.",
  "actionForm.errorReplaceRoute": "Cette action a déjà un parcours. Confirmez que vous voulez le remplacer.",

  "detail.resultsLoading": "Chargement des résultats",
  "detail.resultsLoadingBody": "Lecture des résultats sans modifier Firestore.",
  "detail.resultsLoadError": "Chargement des résultats impossible",
  "detail.resultsLoadErrorBody": "Les résultats apparaîtront lorsqu'ils seront disponibles et lisibles.",
  "detail.noFinishers": "Aucune arrivée pour le moment.",
  "detail.nonFinishers": "Abandons / Non terminés",
  "detail.athlete": "Athlète",
  "detail.resultWithdrawn": "Abandon",
  "detail.resultDnf": "N'a pas terminé",
  "detail.resultDisqualified": "Disqualifié",

  "results.pageTitle": "Résultats",
  "results.pageSubtitle": "Sélectionnez une action et consultez clairement les arrivées, abandons et l'export CSV.",
  "results.title": "Résultats de l'action",
  "results.subtitle": "Classement et données de résultats publiques sûres.",
  "results.selectAction": "Sélectionner une action",
  "results.selectActionBody": "Les actions publiques Brevet ou Race pouvant avoir des résultats sont affichées ici.",
  "results.loadingActions": "Chargement des actions",
  "results.noActionsTitle": "Aucune action avec résultats",
  "results.noActionsBody": "Les actions publiques Brevet ou Race apparaîtront ici lorsqu'elles seront disponibles.",
  "results.chooseActionTitle": "Sélectionnez une action",
  "results.chooseActionBody": "Ouvrez une action de la liste pour afficher ses résultats.",
  "results.exportCsv": "Exporter les résultats CSV",
  "results.ranking": "Classement",
  "results.rankingBody": "Seuls les athlètes avec le statut FINISHED reçoivent un rang.",
  "results.nonFinishedBody": "Les abandons, non-terminés et disqualifiés sont affichés sans rang.",
  "results.filterAll": "Tous",
  "results.filterFinished": "Terminés",
  "results.filterNonFinished": "Abandons / Non terminés",
  "results.searchName": "Rechercher un nom",
  "results.emptyFiltered": "Aucun résultat pour ce filtre.",
  "results.rank": "Rang",
  "results.status": "Statut",
  "results.athlete": "Athlète",
  "results.duration": "Durée",
  "results.distance": "Distance",
  "results.avgSpeed": "Vitesse moy.",
  "results.maxSpeed": "Vitesse max",
  "results.elevationGain": "Dénivelé",
  "results.finishTime": "Arrivée",
  "results.totalResults": "Total",
  "results.finishers": "Arrivées",
  "results.withdrawnDnf": "Hors classement",
  "results.fastestDuration": "Meilleur temps",
  "results.averageFinishDuration": "Temps moyen",
  "results.statusFinished": "Terminé",
  "results.statusWithdrawn": "Abandon",
  "results.statusDnf": "N'a pas terminé",
  "results.statusDisqualified": "Disqualifié",

  "detail.noDescription": "Aucune description pour cette action.",
  "detail.untilStart": "Jusqu'au départ",
  "detail.basedOnDuration": "Selon la durée",
  "detail.time": "Horaires",
  "detail.start": "Début",
  "detail.end": "Fin",
  "detail.registrationDeadline": "Date limite d'inscription",
  "detail.location": "Lieu",
  "detail.noStartLocation": "Aucun lieu de départ défini",
  "detail.participation": "Participation",
  "detail.limit": "Limite",
  "detail.organizer": "Organisateur",
  "detail.route": "Parcours",
  "detail.routePreview": "Aperçu du parcours",
  "detail.routePreviewDescription": "{routePoints} points d'aperçu et {controlPoints} points control sont disponibles.",
  "detail.routePreviewEmpty": "Le parcours apparaîtra ici quand un aperçu de carte sera disponible.",
  "detail.links": "Liens",
  "detail.liveRace": "Live race",
  "detail.missingLinkTitle": "Le lien est incomplet",
  "detail.missingLinkBody": "Aucun identifiant d'action dans ce lien.",
  "detail.loadingAction": "Chargement de l'action",
  "detail.loadingActionBody": "Lecture depuis Firestore.",
  "detail.loadErrorTitle": "Chargement impossible",
  "detail.loadErrorBody": "L'action n'est pas disponible ou la lecture n'est pas autorisée.",
  "detail.unavailableTitle": "L'action n'est pas disponible",
  "detail.unavailableBody": "Les actions supprimées, brouillons ou annulées ne sont pas affichées publiquement.",
  "detail.nonRaceResultsBody": "Les résultats apparaissent pour les actions Brevet ou course lorsqu'ils sont disponibles.",
  "detail.manageTitle": "Gestion de l'action",
  "detail.manageBody": "Outils organisateur pour participants, invitations et support/control.",
  "detail.participantsPublicBody": "Vue publique des noms de participants sûrs.",
  "detail.participant": "Participant",
  "detail.participates": "Participe",
  "detail.loadingParticipants": "Chargement des participants...",
  "detail.participantsLoadError": "Les participants n'ont pas pu être chargés.",
  "detail.noParticipants": "Aucun participant pour le moment.",
  "detail.loadingPermissions": "Chargement des droits",
  "detail.loadingPermissionsBody": "Vérification du compte.",
  "detail.shareTools": "Partager l'action",
  "detail.shareToolsBody": "Copiez un texte propre ou un lien social avec le bon aperçu Facebook.",
  "detail.copyShareText": "Copier le texte de partage",
  "detail.copyShareLink": "Copier le lien social",
  "detail.facebookPreviewLink": "Voir l'aperçu social",
  "detail.shareCopied": "Copié.",
  "detail.shareCopyFailed": "Copie impossible.",
  "detail.shareOpenInPuls": "Ouvrir dans PULS :",
  "detail.shareDownloadPuls": "Téléchargez PULS :",
  "detail.shareFooter": "PULS - pour les vélos et bien plus 🚴",
  "detail.shareParticipants": "{current} participants",
  "detail.shareParticipantsWithLimit": "{current}/{max} participants",

  "roadbook.title": "Roadbook",
  "roadbook.subtitle": "Table des points du parcours avec km, type, horaires et visibilité.",
  "roadbook.routeEditorTitle": "Roadbook du parcours",
  "roadbook.routeEditorSubtitle": "Tous les marqueurs de l'espace de travail triés par km.",
  "roadbook.savedRouteTitle": "Roadbook du parcours",
  "roadbook.savedRouteSubtitle": "POI et controls du parcours enregistré.",
  "roadbook.actionTitle": "Roadbook de l'action",
  "roadbook.publicSubtitle": "Points publics du parcours visibles par les athlètes.",
  "roadbook.loading": "Chargement des points du parcours...",
  "roadbook.print": "Imprimer le Roadbook",
  "roadbook.exportCsv": "Exporter CSV",
  "roadbook.km": "km",
  "roadbook.type": "Type",
  "roadbook.markerTitle": "Titre",
  "roadbook.description": "Description",
  "roadbook.openTime": "Ouverture",
  "roadbook.closeTime": "Fermeture",
  "roadbook.visibility": "Visibilité",
  "roadbook.actions": "Actions",
  "roadbook.visible": "Visible aux athlètes",
  "roadbook.hidden": "Masqué",
  "roadbook.empty": "Aucun point de parcours.",
  "roadbook.noKm": "Sans km",
  "roadbook.farFromRoute": "Loin du parcours",
  "roadbook.publicCount": "{count} publics",
  "roadbook.hiddenCount": "{count} masqués",
  "roadbook.edit": "Modifier",
  "roadbook.recalculateKm": "Recalculer les km",
  "roadbook.kmRecalculated": "Les km des marqueurs ont été mis à jour.",
  "roadbook.kmAlreadyUpdated": "Les km des marqueurs sont déjà à jour.",

  "community.routesTitle": "Parcours communautaires",
  "community.routesSubtitle": "Parcours publics publiés depuis l'application Android.",
  "community.routesCount": "{count} parcours",
  "community.routeDescription": "Parcours public communautaire",
  "community.routeFallback": "Parcours communautaire",
  "community.byAuthor": "Par {name}",
  "community.noRating": "Sans note",
  "community.hiddenEndpoints": "Extrémités masquées",
  "community.loadingRoutes": "Chargement de la communauté",
  "community.loadingRoutesBody": "Lecture des communityRoutes publiques.",
  "community.routesLoadError": "Chargement impossible",
  "community.routesLoadErrorBody": "La communauté nécessite une connexion et des parcours publics publiés.",
  "community.noRoutes": "Aucun parcours publié",
  "community.noRoutesBody": "Les parcours apparaissent ici lorsqu'ils sont publiés depuis l'application.",
  "community.topRated": "Meilleures notes",
  "community.difficultyEasy": "Facile",
  "community.difficultyModerate": "Modérée",
  "community.difficultyHard": "Difficile",
  "community.difficultyExpert": "Expert",
  "community.suitableHiking": "Marche",
  "community.suitableRoad": "Route",
  "community.segmentsTitle": "Segments",
  "community.segmentsSubtitle": "Segments/montées publics depuis l'application, séparés par profil de mouvement.",
  "community.segmentsCount": "{count} segments",
  "community.segmentDescription": "Segment public communautaire",
  "community.segmentFallback": "Segment",
  "community.noProfile": "Sans profil",
  "community.profileHiking": "Randonnée",
  "community.attempts": "tentatives",
  "community.loadingSegments": "Chargement des segments",
  "community.loadingSegmentsBody": "Lecture des communitySegments ACTIVE PUBLIC.",
  "community.segmentsLoadErrorBody": "La lecture des segments nécessite une connexion et des segments publics actifs.",
  "community.noSegments": "Aucun segment pour le moment",
  "community.noSegmentsBody": "Les segments apparaissent ici lorsqu'ils sont créés depuis un parcours enregistré dans l'application.",
  "community.leaderboardTitle": "Classement des segments",
  "community.leaderboardSubtitle": "Uniquement les tentatives VALID, séparées par profil de mouvement.",
  "community.loadingLeaderboard": "Chargement du classement",
  "community.loadingLeaderboardBody": "Lecture des segmentAttempts VALID.",
  "community.leaderboardLoadErrorBody": "Le classement nécessite une connexion et des tentatives valides.",
  "community.noAttempts": "Aucune tentative valide pour le moment",
  "community.noAttemptsBody": "Les tentatives NEEDS_REVIEW et REJECTED ne sont pas affichées dans le classement."
} satisfies Record<string, string>;
